module.exports = __webpack_public_path__ + "static/img/3.e14a18a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/people/frede/3.jpg
// module id = tvsz
// module chunks = 0